/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InboxTestConrollerService {

    /**
     * @param shouldFail 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static getApiAwardInbox1(
shouldFail: boolean = false,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/inbox/1',
            query: {
                'shouldFail': shouldFail,
            },
        });
    }

    /**
     * @param shouldFail 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static getApiAwardInbox2(
shouldFail: boolean = false,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/inbox/2',
            query: {
                'shouldFail': shouldFail,
            },
        });
    }

    /**
     * @param shouldFail 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static getApiAwardInbox3(
shouldFail: boolean = false,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/inbox/3',
            query: {
                'shouldFail': shouldFail,
            },
        });
    }

}
